import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
import { CHECKOUT_URL } from '../utils/checkout';
export function PricingSection() {
  return <section id="offer" className="scroll-mt-20 bg-brand-alt px-4 py-20 md:py-28" data-id="element-139" data-mp="1ei8nbq1m3lum">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-140" data-mp="1eg5p4iqb2met">
        <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-green" data-id="element-141" data-mp="1ja0eo2sldvlt">OFFERTA DI LANCIO</p>
        <h2 className="mb-12 text-3xl font-extrabold text-brand-blue md:text-4xl" data-id="element-142" data-mp="1n9r15ub35pkj">🏷️ Offerta Speciale di Lancio</h2>
        <div className="relative mx-auto max-w-xl rounded-[2rem] border-2 border-brand-red bg-brand-alt p-8 pt-10 shadow-xl md:p-12" data-id="element-143" data-mp="1s7sk8f8ihow0">
          <div className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-brand-red px-5 py-2 text-[10px] font-extrabold tracking-[0.14em] text-white" data-id="element-144" data-mp="227t545m14d2b">
            ARTE PRONTA™
          </div>
          <div className="space-y-4 text-left" data-id="element-145" data-mp="7utk1wyvqqnn">
            <PriceLine label="8 Volumi Completi" price="97 €" data-id="element-146" data-mp="7vmup90ym0b2" />
            <PriceLine label="5 Bonus Esclusivi" price="128 €" data-id="element-147" data-mp="1mhg88g7t0x7z" />
            <div className="flex items-center justify-between border-t border-brand-dark pt-5 text-sm font-bold" data-id="element-148" data-mp="1hpg389cvne4j">
              <span data-id="element-149" data-mp="1crwqxezqpbf8">TOTALE VALORE</span>
              <span className="text-brand-gray line-through" data-id="element-150" data-mp="1cosg3yrrrhfl">225 €</span>
            </div>
          </div>
          <div className="my-8 border-y border-brand-dark py-7" data-id="element-151" data-mp="17ppbugjm5f8o">
            <p className="text-xs font-extrabold tracking-[0.16em] text-brand-green" data-id="element-152" data-mp="25e7sarv67gd3">SOLO OGGI</p>
            <p className="mt-2 font-display text-6xl font-extrabold tracking-tight text-brand-red md:text-7xl" data-id="element-153" data-mp="20hr1fpwl6nwb">
              19 <span className="text-2xl" data-id="element-154" data-mp="1vfjksn0tajnn">EUR</span>
            </p>
            <p className="mt-2 text-xs font-semibold text-brand-gray" data-id="element-155" data-mp="1rgj87m8xgd93">(pagamento unico)</p>
          </div>
          <CTAButton href={CHECKOUT_URL} className="w-full py-5 text-base md:text-lg" data-id="element-156" data-mp="k38ymzgkpls6">
            OTTIENI ARTE PRONTA™ ORA
          </CTAButton>
          <p className="mt-6 text-xs font-semibold text-brand-gray" data-id="element-157" data-mp="g2ywjxvwjfil">
            Pagamento unico. Nessun abbonamento. Accesso immediato.
          </p>
        </div>
      </Reveal>
    </section>;
}
function PriceLine({
  label,
  price
}: {
  label: string;
  price: string;
}) {
  return <div className="flex items-center justify-between gap-4 border-b border-brand-dark pb-4 text-sm" data-id="element-158" data-mp="7jc2wxus9uf8">
      <span className="font-medium" data-id="element-159" data-mp="cgu4g36h17d7">{label}</span>
      <span className="whitespace-nowrap font-bold text-brand-blue" data-id="element-160" data-mp="3uwedie5synrp">{price}</span>
    </div>;
}